import { addToTimingMap } from './utils/timingMap';

let eventTimeToSourceMapping: Map<number, string> = new Map();

export function getEventTimeMapping(startTime: number): string | undefined {
    return eventTimeToSourceMapping.get(startTime);
}

export function resetEventTimeToSourceMapping(): void {
    eventTimeToSourceMapping = new Map();
}

export function addEventTimeToSourceMapping(evt: Event, source: string): void {
    const value = `${evt.type}:${source}`;
    addToTimingMap('eventListener', value);
    eventTimeToSourceMapping.set(evt.timeStamp, value);
}
